import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_labpronics-tech/artifacts/a7d11asc_ChatGPT%20Image%20Aug%204%2C%202026%2C%2003_51_10%20AM.png";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full border border-lp-border rounded-sm px-4 py-3 text-sm focus:outline-none focus:border-lp-cyan focus:ring-1 focus:ring-lp-cyan";

  return (
    <div className="min-h-screen bg-lp-grey flex items-center justify-center p-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="bg-white border border-lp-border rounded-sm p-10 w-full max-w-md shadow-[0_30px_60px_-30px_rgba(10,43,110,0.3)]">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO} alt="Labpronics" className="h-11 w-11 object-contain" />
          <div>
            <div className="font-heading font-700 text-lp-blue text-lg leading-none">Labpronics Admin</div>
            <div className="text-xs text-lp-muted mt-1">Content &amp; Enquiry Console</div>
          </div>
        </div>
        <label className="text-xs font-600 text-lp-ink">Email</label>
        <input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls + " mb-4 mt-1"} />
        <label className="text-xs font-600 text-lp-ink">Password</label>
        <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls + " mt-1"} />
        {err && <p className="text-sm text-destructive mt-4">{err}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-lp-blue text-white font-600 py-3.5 rounded-sm hover:bg-lp-steel transition-colors disabled:opacity-60">
          <Lock size={16} /> {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
